module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/Slice 26@2x.23c70033.png";